import { CopyOutlined, DesktopOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Row, Space, Table, message, Input } from 'antd'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { PageHeader } from '~/components/PageHeader'
import { useTableDataSourceKey } from '~/hooks/useTableDataSourceKey'
import { clipboard, compareText } from '~/utils/helpers'
import { useNativeAppstreamLinkMutation } from './mutation'
import { useCourseParticipantsQuery, useCourseQuery } from './query'

const columns = ({ id, copyNativeLink }) => [
  {
    title: 'ID',
    render: (student) => student?.id
  },
  {
    title: 'Alias',
    render: (student) => student?.alias
  },
  {
    title: 'Name',
    render: (student) => `${student?.first_name} ${student?.last_name}`,
    sorter: (a, b) =>
      compareText(`${a.first_name} ${a.last_name}`, `${b.first_name} ${b.last_name}`)
  },
  {
    title: 'Username',
    render: (student) => student?.username
  },
  {
    title: 'Password',
    render: (student) => student?.password
  },
  {
    title: 'Email',
    render: (student) => student?.email,
    sorter: (a, b) => compareText(a.email, b.email)
  },
  {
    title: 'Action',
    render: (item) => {
      return (
        <Space size="middle">
          <Button
            key={1}
            type="primary"
            icon={<CopyOutlined />}
            onClick={() => {
              clipboard(
                `${window.location.origin}/workstation-info/${item?.appstream_token}`
              )
              message.success('Copied')
            }}
          >
            Copy link
          </Button>
          {/* <Button
            key={2}
            type="primary"
            icon={<CopyOutlined />}
            onClick={() => copyNativeLink(item.id)}
          >
            Copy native link
          </Button> */}
          <a
            key={3}
            href={item.workstation_link}
            target="_blank"
            style={{ color: 'white', marginLeft: 5 }}
            rel="noreferrer"
          >
            <Button type="primary" icon={<DesktopOutlined />}>
              Open workstation
            </Button>
          </a>
        </Space>
      )
    }
  }
]

const DoctorWorkstationDetails = () => {
  const { id } = useParams()
  const { data, isLoading } = useCourseParticipantsQuery(id)
  const dataSource = useTableDataSourceKey(data)
  const [filterInput, setFilterInput] = useState('')
  const { data: course } = useCourseQuery(id)
  const { mutate: copyNativeLink } = useNativeAppstreamLinkMutation(id)

  const filterData = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!dataSource) {
      return []
    }

    return dataSource.filter(
      (student) =>
        `${student.first_name} ${student.last_name}`.toLowerCase().includes(filter) ||
        student.email.toLowerCase().includes(filter)
    )
  }, [dataSource, filterInput])

  if (!course) {
    return null
  }

  return (
    <>
      <PageHeader
        className="radup-page-header"
        title={'Workstations > ' + course?.name}
        extra={[
          <Input.Search
            key={1}
            placeholder="Search"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={setFilterInput}
          />
        ]}
        onBack={() => window.history.back()}
      />

      <Table
        size="small"
        tableLayout="auto"
        dataSource={filterData}
        columns={columns({ id, copyNativeLink })}
        loading={isLoading}
        footer={() => (
          <Row justify="start">
            <span>Total: {filterData.length} participants</span>
          </Row>
        )}
      />
    </>
  )
}

export default DoctorWorkstationDetails
